<template>
  <div class="pogs-list__item"
       :class="isSelectedPatient(patient._id)"
       @click.stop="showHidePreview() | hideNav()">
    <div class="patient-img">
      <div class="smd-profile-image m">
        <template v-if="!patient.avatar">
          {{initials}}
        </template>
      </div>
    </div>

    <div class="patient-data">
      <div class="patient-data__details">
        <div class="patient-data__name">
          <h3>{{patient.firstName}} {{patient.middleName}} {{patient.lastName}}</h3>
        </div>
        <div class="patient-data__meta">
          <p><label>DOB:</label> {{patient.birthDate | formatDate}}</p>
          <p><label>AGE:</label> {{patient.birthDate | computeAge}}</p>
        </div>
      </div>

      <!--
      <div class="patient-data__status" v-if="patient.admissionInfo != null">
        <div class="pogs-tag--pill yellow-tag">Admitted</div>
        <label dark-normal>
          <strong>Rm {{patient.admissionInfo.room}}</strong>
        </label>
      </div>-->
    </div>
    <!--
    <div class="patient-case">
      <div v-if="patient.hasOpenCase" class="patient-case__status open"/>
    </div>-->
  </div>
</template>

<script>
  import uiHelper from '../../../mixins/uihelper'
  import Routes from '../../../router/route-constants'
  import Store from '../../../../src/store/store'
  import {MUTATE_SHOW_NAV} from "../../../store/modules/shared";

  export default {
    name: "pogs-list__item--patient",
    props: {
      patient: {
        patientId: String,
        firstName: String,
        lastName: String,
        avatar: String,
        birthDate: String,
        hasOpenCase: false
      }
    },
    mixins: [uiHelper],
    data(){
      return{
        activeID: null
      }
    },
    computed:{
      selectedPatientId() {
        return this.$route.params.patientid
      },
      initials(){
        return this.patient.firstName && this.patient.lastName ?
          this.patient.firstName.substring(0,1).toUpperCase() + this.patient.lastName.substring(0,1).toUpperCase() : ' ';
      }
    },
    methods: {
      isSelectedPatient(patientId){
        if(this.showPreview){
          return this.$route.params.patientid  === patientId ? 'active' : undefined;
        }
      },
      showHidePreview(){
        this.togglePreview();
        this.$router.push({
          name: Routes.ROUTE_PATIENT_PROFILE_PREVIEW,
          params: { patientid: this.patient._id}
        })
      },
      caseInitial(isPregnancy, gynecologicalDiagnosis){
        const OB_PATIENT_INITIAL      = 'OB';
        const GYNE_PATIENT_INITIAL    = 'GN';
        const OB_GYNE_PATIENT_INITIAL = 'OG';
        const UNKNOWN_INITIAL         = 'UN';
        let isGyne = false;
        if(gynecologicalDiagnosis instanceof Object){
          if(Object.keys(gynecologicalDiagnosis).length > 0){
            isGyne = true
          }
        }
        if(isGyne && isPregnancy) return OB_GYNE_PATIENT_INITIAL;
        else if(isGyne && !isPregnancy) return GYNE_PATIENT_INITIAL;
        else if(!isGyne && isPregnancy) return OB_PATIENT_INITIAL;
        else return UNKNOWN_INITIAL
      },
      patientInitialBackground(isPregnancy, gynecologicalDiagnosis){
        const OB_PATIENT_COLOR      = '#00FFFF';
        const GYNE_PATIENT_COLOR    = '#FF7F50';
        const OB_GYNE_PATIENT_COLOR = '#FFD700';
        const UNKNOWN_COLOR         = 'C6C5C5';
        let isGyne = false;
        if(gynecologicalDiagnosis instanceof Object){
          if(Object.keys(gynecologicalDiagnosis).length > 0){
            isGyne = true
          }
        }
        if(isGyne && isPregnancy) return {background: OB_GYNE_PATIENT_COLOR};
        else if(isGyne && !isPregnancy) return {background: GYNE_PATIENT_COLOR};
        else if(!isGyne && isPregnancy) return {background: OB_PATIENT_COLOR};
        else return {background: UNKNOWN_COLOR}
      },
      hideNav() {
          Store.commit(MUTATE_SHOW_NAV, false);
      }
    }

  }
</script>
